import { __assign } from '../../../_virtual/_tslib.js';
import * as React from 'react';

var SvgFeatherChevronRightCircle = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }, props),
    React.createElement("circle", { cx: 12, cy: 12, r: 10 }),
    React.createElement("path", { d: "m10 8 4 4-4 4" }))); };

export { SvgFeatherChevronRightCircle as default };
